// extracted by mini-css-extract-plugin
export var menuIcon = "_rm-0";
export var menuIconInline = "_rm-1";